import cn from 'clsx'
import './ToggleButtons.css'
import { useEffect } from 'react'

/**
 * @typedef ToggleButton
 * @property {string} label
 * @property {string} key
 * 
 * @typedef ToggleButtonsProps
 * @property {ToggleButton[]} buttons
 * @property {string[] | string} state
 * @property {function(string[] | string): void} setter
 * @property {boolean} [multiple]
 * @property {string?} label
 * 
 * @param {ToggleButtonsProps} props
 * @returns {JSX.Element}
 */
const ToggleButtons = ({ buttons, state, setter, multiple = false, label }) => {
    
    useEffect(() => {
        if (state) {
            if (multiple && !Array.isArray(state))
                console.warn('State should be a `string` not an `array`, it will be changed by the setter')
            else if (!multiple && Array.isArray(state))
                console.warn('State should be an `array` not a `string`, it will be changed by the setter')
        }
    }, [multiple, state])
    
    const toggleButton = key => {
        if (multiple) return toggleButtonMultiple(key)
        toggleButtonSimple(key)
    }
    
    const toggleButtonSimple = key => setter(state === key ? null : key)
    
    const toggleButtonMultiple = key => {
        const copyState = [...state]
        const keyIdx = copyState.indexOf(key)
        
        if (keyIdx > -1) {
            copyState.splice(keyIdx, 1)
        } else {
            copyState.push(key)
        }
        
        setter(copyState)
    }
    
    const isActive = key => 
        state === key || (Array.isArray(state) && state.includes(key))
    
    return (
        <div>
            {label && <label>{label}</label>}
            <div className="toggle-buttons">
                {buttons.map(btn => <button
                    key={btn.key}
                    className={cn({ 'active': isActive(btn.key) })}
                    onClick={() => toggleButton(btn.key)}>
                    {btn.label}
                </button>)}
            </div>
        </div>
    )
}

export default ToggleButtons
